module.exports = __webpack_public_path__ + "media/newstyle/images/linkedin-03f1d164221e3a81954e6ec24a350288.svg";